module.exports = __webpack_public_path__ + "static/media/toyota.e653875e.png";